import { Accordion, SofturaTable } from "client/CommonComponents";
import './ChangeLog.scss';
import { update_data } from "client/utils/changeLogColumns";

const ChangeLog = (props:any) => {
  const {
    changeLogColumn
  } = props;
  let updated_array:any=[]
  if (props.Data) {
    updated_array = update_data(props?.Data)
  }

    const ExpandedItems = [
        {
          headerText: (
            <div className="accordionHeader">
              <div className="accordionHeaderLeft mt-1">
                <p className="accord-heading">
                  CHANGE LOG
                </p>
              </div>
            </div>
          ),
        content:<div className="softura-table mb-3 p-3">
                    <SofturaTable 
                        data={updated_array}
                        columns={changeLogColumn}
                        sort={true}
                        defaultPageSize={10}
                        pageSizes={[10,20,50]}
                        globalSearch={false}
                        fixedHeader={true}
                     data-attribute="ChangeLog_Default_Grid" />
                </div>,
        uuid:`Fleet_ChangeLog_Accordion`,
        },
    ];
    return(
        <div className={`ChangeLog ChangeLog-Asset px-3`}>
        <Accordion
            Items={ExpandedItems}
            className="custom-accordion LeaderOrderAccordion capitalLizeAccord"
            onChange={props.onExpandChangeLog}
         data-attribute="ChangeLog_Default_Accordion" />
        </div>
    )
}

export default ChangeLog;